import { Link } from 'react-router-dom';
import { mainSiteUrl, externalLinkAttrs } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20editorial%20photo%20of%20a%20curated%20wardrobe%20display%20on%20an%20open%20clothing%20rack%20featuring%20jackets%20hoodies%20and%20accessories%20with%20a%20large%20window%20casting%20natural%20morning%20light%20across%20the%20scene%2C%20minimalist%20loft%20interior%2C%20warm%20beige%20and%20cream%20tones%2C%20elegant%20boutique%20atmosphere%2C%20soft%20shadows%2C%20ample%20negative%20space%20for%20text&width=1800&height=1200&seq=hero-bg-v2-2026&orientation=landscape"
          alt="Curated Sugargoo Spreadsheet fashion collection display"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 flex flex-col justify-center flex-1 w-full px-6 md:px-10 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row lg:items-center gap-12 lg:gap-20 max-w-7xl mx-auto w-full">
          <div className="lg:w-1/2">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-none tracking-tight">
              Sugargoo<br />Spreadsheet<br />2026
            </h1>
            <p className="mt-4 md:mt-6 text-lg md:text-xl text-white/80 font-light max-w-md">
              Best Curated Finds
            </p>
          </div>

          <div className="lg:w-1/2 flex flex-col items-start lg:items-end gap-6">
            <p className="text-base md:text-lg text-white/70 max-w-sm lg:text-right leading-relaxed">
              The largest Sugargoo spreadsheet resource center — curated finds, buying guides, and direct links to verified sellers.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={mainSiteUrl}
                {...externalLinkAttrs}
                className="group flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white text-sm font-medium hover:bg-white/10 transition-all whitespace-nowrap"
              >
                <span>Visit Main Website</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
                </span>
              </a>

              <Link
                to="/article/best-sugargoo-spreadsheet-2026"
                className="px-6 py-3 rounded-full bg-white text-foreground-950 text-sm font-semibold hover:bg-white/90 transition-colors whitespace-nowrap"
              >
                Read Our Guide
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 max-w-7xl mx-auto w-full">
          <div className="rounded-2xl overflow-hidden h-[300px] md:h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Top%20down%20flat%20lay%20of%20meticulously%20arranged%20fashion%20pieces%20including%20leather%20bags%2C%20watches%2C%20sunglasses%2C%20and%20folded%20clothing%20on%20a%20warm%20terracotta%20linen%20surface%2C%20soft%20diffused%20overhead%20lighting%2C%20luxury%20editorial%20photography%2C%20rich%20earthy%20color%20palette%2C%20organized%20grid%20composition&width=1600&height=500&seq=hero-banner-v2-2026&orientation=landscape"
              alt="Sugargoo Spreadsheet product showcase flat lay"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}